'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _closeButton = require('@hixme-ui/close-button');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _IconSpan = require('./IconSpan');

var _IconSpan2 = _interopRequireDefault(_IconSpan);

var _StyledSidebarContent = require('./StyledSidebarContent');

var _StyledSidebarContent2 = _interopRequireDefault(_StyledSidebarContent);

var _StyledSidebarHeader = require('./StyledSidebarHeader');

var _StyledSidebarHeader2 = _interopRequireDefault(_StyledSidebarHeader);

var _Wrapper = require('./Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sidebar = function Sidebar(_ref) {
  var children = _ref.children,
      header = _ref.header,
      onClose = _ref.onClose,
      open = _ref.open,
      sidebarWidth = _ref.sidebarWidth,
      style = _ref.style,
      topOffset = _ref.topOffset;
  return _react2.default.createElement(
    _Wrapper2.default,
    { topOffset: topOffset, open: open, sidebarWidth: sidebarWidth, style: style },
    _react2.default.createElement(
      _StyledSidebarHeader2.default,
      null,
      _react2.default.createElement(
        'h3',
        null,
        header,
        _react2.default.createElement(
          _IconSpan2.default,
          null,
          _react2.default.createElement(_closeButton2.default, { onClick: onClose, noLabel: true })
        )
      )
    ),
    _react2.default.createElement(
      _StyledSidebarContent2.default,
      null,
      children
    )
  );
};

// hixme-ui


Sidebar.propTypes = {
  children: _propTypes2.default.node.isRequired,
  header: _propTypes2.default.string,
  onClose: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool,
  sidebarWidth: _propTypes2.default.string,
  style: _propTypes2.default.object,
  topOffset: _propTypes2.default.number
};

Sidebar.defaultProps = {
  header: '',
  open: false,
  sidebarWidth: '300px',
  style: {},
  topOffset: 58
};

exports.default = Sidebar;
//# sourceMappingURL=Sidebar.js.map


//////////////////
// WEBPACK FOOTER
// ../sidebar/lib/Sidebar.js
// module id = 751
// module chunks = 0